import enUK from './en-UK'

export default {
  ...enUK,
  message: {
    greeting: 'g\'day, {name}'
  }
}
